export default __webpack_public_path__ + "static/media/followUpSchedule.4f955c93.png";